import { UserOnboarding } from '@/domain/usecases/onboarding/user-onboarding'
import { queryClient } from '@/infra/http'
import { importRemote } from '@/main/routes/helpers/loaders'

/**
 * Loads onboarding data for the main layout
 * Fetches user onboarding information
 */
export async function loadOnboardingMainLayout() {
  const remoteUserOnboarding = await importRemote<UserOnboarding>(
    'makeRemoteUserOnboarding',
    queryClient
  )

  return remoteUserOnboarding.get()
}
